// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__oT5mq","messages":"Section_messages__1MPS4","header":"Section_header__2Nj4s","content":"Section_content__23BLV"};